import { render, staticRenderFns } from "./CardHome.vue?vue&type=template&id=7ffeaaa2&scoped=true&lang=pug&"
import script from "./CardHome.vue?vue&type=script&lang=js&"
export * from "./CardHome.vue?vue&type=script&lang=js&"
import style0 from "./CardHome.vue?vue&type=style&index=0&id=7ffeaaa2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffeaaa2",
  null
  
)

export default component.exports